<template lang="pug">
  v-container.pa-0
    v-row( justify='center' )
      v-col
        v-text-field(
          v-model='texto_buscador' 
          @keyup.enter='ir()' 
          label='Buscar' 
          outlined 
          color='red' 
          rounded 
          prepend-inner-icon='fa-search'
          @click:append=" ir()"
        ).mx-6.mt-6
        router-link(  :to="{name:'productos'}"  color='transparent' heigth='100%' style='text-decoration: none' ).boton-menu.azul--text.d-none.d-md-flex
          v-icon.mr-2 fa-angle-down
          small Líneas comerciales
        v-treeview(expand-icon='fa-angle-down'  open-on-click  :items='Items'  item-key='name' ).mx-6.mt-2.d-none.d-md-block
          template( slot="label" slot-scope="props")
            router-link(  :to="props.item.to" v-if="props.item.to" color='transparent' heigth='100%' style='text-decoration: none' ).boton-menu.azul--text
              small {{ props.item.name }}
            span( v-else ).text-uppercase {{ props.item.name }}
     
</template>
<script>
export default {
  methods: {
    ir(){
      this.$router.push({name: 'productos', params:{busqueda:this.texto_buscador}}).catch(()=>{})
    }
  },
  data: () => ({
      activar_buscador: true,
      texto_buscador:'',
      filtro:'',
      texto_filtro:'',
      seleccionado: [],
    }),
  computed: {
    Lineas_comerciales() {
      return this.$contenido.Lineas_Comerciales ? this.$contenido.Lineas_Comerciales.lineas_comerciales : []
    },
    Categorias() {
      return this.$contenido.Lineas_Comerciales ? this.$contenido.Lineas_Comerciales.categorias : []
    },
    Marcas(){
      return this.$contenido.Lineas_Comerciales ? this.$contenido.Lineas_Comerciales.marcas : []
    },
    Items(){
      let o =[ ]
      this.Lineas_comerciales.map( i => o.push({name: i.nombre, to: {name: 'productos', params: {linea_comercial: i.nombre}}}))
      o = o.map( i=> ({...i, children: this.Categorias.filter( j => j.linea_comercial == i.name).map( c => ({ name: c.categoria,  to: {name: 'productos', params: {categoria: c.categoria, linea_comercial: i.name}}})) }) )
      return o
    }
  },
  components:{
    Marcas_Aliadas:()=> import('./marcas_aliadas'),
  }
}
</script>
<style lang="sass">
.boton-menu
  .v-btn__content
    padding: 15px 20px
    max-width: 140px
    white-space: normal
    text-align: left
</style>